compiler('#ajax-modal-form', (form) => {
  const modal = bootstrap.Modal.getOrCreateInstance(form.closest(".modal"));
  const instanceId = form.dataset.instanceId;
  const instanceModel = form.dataset.instanceModel;
  const submitButton = document.getElementById('ajax-form-submit');
  const inputs = form.querySelectorAll('input');
  addEventListeners();

  function fetchUpdateTracking() {
    fetch(form.action, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': document.querySelector('input[name="authenticity_token"]').value
      },
      body: new FormData(form)
    }).then(response => {
      if(response.ok) {
        modal.hide();
        response.text().then(data => {
          updateAndShowSuccessForInstance(data);
        })
      }
      else {
        response.json().then(data => {
          showValidationErrors(data);
        })
      }
    })
  }

  function showValidationErrors(response) {
    resetFieldErrors();
    processFieldErrors(response);
  }

  function resetFieldErrors() {
    Array.from(form.querySelectorAll('.is-invalid')).forEach(function(el) {
      el.classList.remove('is-invalid');
    });
  }

  function processFieldErrors(response) {
    if (response.hasOwnProperty("errors")) {
      response["errors"].forEach((errors) => {
        for (let instance in errors) {
          instanceErrors = errors[instance];
          Object.entries(instanceErrors).forEach(([attribute, message]) => {
            let fieldInstanceName = instance;
            if (isNestedAttribute(attribute)) {
              let [nestedInstance, nestedAttribute] = attribute.split('.');
              attribute = nestedAttribute;
              fieldInstanceName = `${fieldInstanceName}[${nestedInstance}_attributes]`;
            }
            setFieldError(fieldInstanceName, attribute, message);
          })
        }
      })
    }
  }

  function setFieldError(instance, attribute, message) {
    inputName = `${instance}[${attribute}]`;
    input = document.getElementsByName(inputName)[0];
    if (input) {
      input.classList.add("is-invalid");
      input.setCustomValidity(message);
      input.reportValidity();
    }
  }

  function updateAndShowSuccessForInstance(data) {
    wrapper = document.getElementById(instanceModel + '_' + instanceId + '_wrapper');
    wrapper.innerHTML = data;
    $(wrapper).effect('highlight',{color: '#c3e6cb'}, 3000);
  }

  function addEventListeners() {
    submitButton.addEventListener("click", fetchUpdateTracking);
    inputs.forEach(element => {
      element.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault;
          fetchUpdateTracking();
        }
      });
    });
  }

  function isNestedAttribute(attribute) {
    return attribute.includes(".");
  }
})
